import { memo, useCallback } from 'react';
import { useSeStore } from '@/store/seStore';
import { Range } from '../Range';

export const SeSettings = memo(function SeSettings() {
  const { seVolume: volume, setSeVolume } = useSeStore();

  const handleSeVolumeChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setSeVolume(parseInt(e.target.value, 10));
    },
    [setSeVolume],
  );

  return (
    <section className="grid gap-16">
      <header className="flex items-center justify-between text-xl">
        <h3 className="font-bold text-gray-800">効果音音量</h3>
        <b className="text-[1.2em] text-purple-600">{volume}</b>
      </header>

      <Range
        value={volume}
        onChange={handleSeVolumeChange}
        ariaLabel="効果音音量"
        style={{
          background: `linear-gradient(to right, rgb(147, 51, 234) 0%, rgb(147, 51, 234) ${volume}%, rgb(229, 231, 235) ${volume}%, rgb(229, 231, 235) 100%)`,
        }}
      />
    </section>
  );
});
